import React from 'react'

export default props => <svg
  width="11"
  height="25"
  viewBox="0 0 11 25"
  fill="#909AAA"
  {...props}
>
  <circle cx="2" cy="2" r="2" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(7)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(0 7)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(7 7)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(0 14)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(7 14)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(0 21)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  <circle cx="2" cy="2" r="2" transform="translate(7 21)" x2="1" gradientUnits="userSpaceOnUse" gradientTransform="translate(4 4) scale(4) rotate(180)" fillOpacity="0.2"/>
  {/*<defs>
  <linearGradient id="paint0_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint1_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint2_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint3_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint4_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint5_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint6_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  <linearGradient id="paint7_linear" >
  <stop stop-color="#909AAA"/>
  <stop offset="1" stop-color="#7A808C"/>
  </linearGradient>
  </defs>*/}
</svg>



// WEBPACK FOOTER //
// ./src/modules/ControlWrapper/DragHandleSvg.js